import { render, staticRenderFns } from "./cust-info.vue?vue&type=template&id=d213814a&scoped=true"
import script from "./cust-info.vue?vue&type=script&lang=ts"
export * from "./cust-info.vue?vue&type=script&lang=ts"
import style0 from "./cust-info.vue?vue&type=style&index=0&id=d213814a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d213814a",
  null
  
)

export default component.exports